<template>
  <div class="caseDetails">
    <!-- <p class="el-icon-back back" @click="goBack">返回</p> -->
    <div class="moreCase 123">
      <ul>
        <li
          :class="{ active: activeIndex == index }"
          v-for="(item, index) in detailLists"
          :key="index"
          @click="activeFun(index, item.obj.incidentTypeStr)"
        >
          {{ item.obj.obj.otherTypeName || item.obj.incidentTypeStr }}
        </li>
      </ul>
    </div>
    <jiesuan
      :detailLists="detailLists"
      :detailList="detailList"
      :detailsTypeName="detailsTypeName"
    />
    <p class="title">案件详情</p>
    <ParheaderVue :detailList="detailList" />
    <Parinf :detailList="detailList" />
    <div class="btnBox">
      <div>
        <el-button
          :disabled="
            detailList.obj.obj.caseState == 111 ||
            detailList.obj.obj.caseState == 110
          "
          v-if="detailList.obj.obj.caseState != 110"
          type="primary"
          @click="dialogFormVisible = true"
          >确认案件已完成</el-button
        >
        <el-button
          v-if="detailList.obj.obj.incidentType == 600"
          type="primary"
          @click="dialogFormVisible1 = true"
          >关闭星使派遣</el-button
        >
        <el-button
          v-if="detailList.obj.obj.caseState != 110 "
          :disabled="
            detailList.obj.obj.caseState == 111 
          "
          type="primary"
          @click="caseEditor"
          >案件编辑</el-button
        >
        <el-button
          :disabled="
            detailList.obj.obj.caseState == 111 ||
            detailList.obj.obj.caseState == 110
          "
          type="primary"
          @click="
            dialogVisible = true;
            closeId = scope.row.caseId;
          "
          >关闭案件</el-button
        >
        <el-button
          v-if="detailList.obj.obj.incidentType == 600"
          type="primary"
          @click="
            (showcooperaterDialogVisible = true),
              listDomestic(detailList.obj.obj.id)
          "
          >修改协调人</el-button
        >
        <el-button
          v-if="
            detailList.obj.obj.incidentType != 600 &&
            detailList.obj.obj.caseState == 100
          "
          type="primary"
          @click="toHelp"
          >启动救援</el-button
        >
        <el-button
          v-if="$route.query.bidId"
          type="primary"
          @click="offerclick()"
          >报价详情</el-button
        >
        <span v-if="detailList.obj.obj.incidentType == 800">
          <span v-if="detailList.obj.obj.caseState != 100">
            <el-button
          v-if="instiId == 300000125 || instiId == 300000124 || instiId == 300000255 || instiId == 300000275 || instiId == 300000412 || instiId == 300000273 || instiId == 300000274 || instiId == 300000277 || instiId == 1"
          type="primary"
          @click="statusReset()"
          >案件状态重置</el-button
        >
          </span>
          <el-button 
            type="success" 
            @click="extractServiceInfo" 
            style="margin-left: 10px;"
          >一键提取上门信息</el-button>
        </span>
    
      </div>
      <div class="btnWorkbench" v-if="detailList.obj.obj.incidentType">
        <el-button type="primary" @click="openWork">沟通聊天</el-button>
        <el-button
          type="primary"
          @click="zrrd"
          v-if="detailList.obj.obj.insuranceLiabilityStatus == 1"
          >提醒保险责任认定</el-button
        >
        <el-button type="primary">
          <router-link
            :to="{
              name: 'anjianList1',
              query: {
                caseid: detailList.obj.obj.id,
                caseState: detailList.obj.obj.caseState,
                type: detailList.obj.obj.incidentType,
              },
            }"
            >附件列表</router-link
          >
        </el-button>
        <el-button type="primary" @click="centerDialogVisible2 = true"
          >添加回访</el-button
        >
        <el-button type="primary" @click="centerDialogVisible3 = true"
          >添加录音</el-button
        >
      </div>
    </div>
    <jianbao
      :caseId="detailList.obj.obj.id"
      :type="detailList.obj.obj.incidentType"
    />
    <finishDetails :detailList="detailList" :caseId="detailList.obj.obj.id" />
    <el-dialog
      title="添加回访"
      :visible.sync="centerDialogVisible2"
      center
      width="850px"
      :modal-append-to-body="false"
    >
      <div class="jianbao">
        <div>
          <span>回访内容：</span>
          <el-input
            style="width: 600px"
            placeholder="请填写内容"
            v-model="jbTitle"
          ></el-input>
        </div>
        <!-- <div>
          <span>详细内容：</span>
          <el-input
            style="width: 600px"
            type="textarea"
            placeholder="请填写详细内容"
            v-model="uploadIdText"
          ></el-input>
        </div>
        <div>
          <span>通话录音：</span>
          <el-select
            v-model="valueSelect"
            placeholder="请选择"
            style="width: 600px"
          >
            <el-option
              v-for="(item, index) in pstnCallLstList"
              :key="index"
              :label="item.name"
              :value="item.ucnt.id"
            >
            </el-option>
          </el-select>
        </div> -->
      </div>
      <el-button class="popBtn" type="primary" @click="addbrief"
        >确定</el-button
      >
    </el-dialog>
    <el-dialog
      title="添加外部录音"
      :visible.sync="centerDialogVisible3"
      center
      width="650px"
      :modal-append-to-body="false"
    >
      <div class="jianbao">
        <div>
          <span>标题：</span>
          <el-input
            style="width: 400px"
            placeholder="请填写标题"
            v-model="description"
          ></el-input>
        </div>
        <div>
          <span>主叫：</span>
          <el-input
            style="width: 400px"
            placeholder="请填写主叫"
            v-model="descriptionFrom"
          ></el-input>
        </div>
        <div>
          <span>被叫：</span>
          <el-input
            style="width: 400px"
            placeholder="请填写被叫"
            v-model="descriptionTo"
          ></el-input>
        </div>
        <div class="fujian">
          <span>附件：</span>
          <div style="display: inline-block">
            <el-upload
              class="upload-demo"
              action="aaa"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :limit="5"
              :on-exceed="handleExceed"
              :file-list="fileList"
              :before-upload="beforeAvatarUpload"
              :http-request="requestFile"
            >
              <el-button size="small" type="primary" :loading="uploadBtn"
                >点击添加</el-button
              >
              <div slot="tip" class="el-upload__tip">
                可上传5个附件，每个附件大小不得超过8M
              </div>
            </el-upload>
          </div>
        </div>
      </div>
      <el-button class="popBtn" type="primary" @click="uploadFileFun"
        >确定</el-button
      >
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>确认关闭？</span>
      <textarea
        placeholder="请输入关闭原因"
        v-model="closeTxt"
        class="closeTxt"
      ></textarea>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="
            dialogVisible = false;
            closeCase(closeId);
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 弹窗 -->
    <el-dialog
      title="确认完成案件"
      center
      :visible.sync="dialogFormVisible"
      width="800px"
    >
      <div class="popBox">
        <!-- <p style="margin-bottom: 15px">救援费用:</p> -->
        <ul>
          <li>
            <span>救援费用</span>
            <el-input  v-if="detailList.obj.obj.incidentType != 800"  type="number" v-model="rescueFee"></el-input>
            <el-input  v-else  type="number" v-model="rescueFee" @change="jyfychange(rescueFee)"></el-input>
            <span>RMB</span>
          </li>
          <li v-if="detailList.obj.obj.incidentType != 800">
            <span>医疗费用</span>
            <el-input type="number" v-model="medicFee"></el-input>
            <span>RMB</span>
          </li>
          <li>
            <span v-if="detailList.obj.obj.incidentType != 800">其他费用</span>
            <span v-else>纯收入</span>
            <el-input v-if="detailList.obj.obj.incidentType != 800" type="number" v-model="otherFee"></el-input>
            <el-input v-else type="number" disabled v-model="otherFee"></el-input>
            <span>RMB</span>
          </li>
          <li v-if="detailList.obj.obj.incidentType == 800">
            <span style="width: 56px; display: inline-block">邮件备注</span>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="closeText"
            >
            </el-input>
            <!-- <span>RMB</span> -->
          </li>
        </ul>
      </div>
      <div v-if="detailList.obj.obj.incidentType == 800">
        <div>
          <span style="width: 92px; display: inline-block; margin-top: 10px"
            >回访结果：</span
          >
          <el-radio v-model="satisfied" label="1">满意</el-radio>
          <el-radio v-model="satisfied" label="2">不满意</el-radio>
        </div>
        <div v-if="satisfied == '2'">
          <span style="width: 56px; display: inline-block; margin-top: 10px"
            >填写原因</span
          >
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="comments"
          >
          </el-input>
        </div>
      </div>
      <div style="color: red">“确认案件已完成”前请负责人检查！</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureFun()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="关闭星使派单"
      center
      :visible.sync="dialogFormVisible1"
      width="500px"
    >
      <center>是否确认关闭？</center>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="closeCase()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改协调人"
      :visible.sync="showcooperaterDialogVisible"
      center
      top="1vh"
      width="1000px"
      @close="toggleSelection()"
    >
      <span
        class="contactAddStyle"
        @click="addContacterDialogVisible = true"
      ></span>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="修改协调人" name="second">
          <el-table
            empty-text="暂无数据"
            :data="cooperaterData"
            class="mgt15"
            border
            @selection-change="handleSelectionChange"
            ref="multipleTable"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              min-width="30"
            ></el-table-column>
            <el-table-column
              prop="mobileNo"
              label="手机号"
              min-width="30"
            ></el-table-column>
            <el-table-column
              prop="nationalId"
              label="证件号码"
              min-width="30"
            ></el-table-column>
          </el-table>
          <div style="text-align: center; margin-top: 10px">
            <el-button type="primary" @click="diffDomestic()">确定</el-button>
            <el-button
              @click="
                toggleSelection();
                showcooperaterDialogVisible = false;
              "
              >取消</el-button
            >
          </div>
        </el-tab-pane>
        <el-tab-pane label="非公司隶属的协调人" name="first">
          <el-table
            empty-text="暂无数据"
            :data="cooperaterData1"
            class="mgt15"
            border
            @selection-change="handleSelectionChange1"
            ref="multipleTable1"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              min-width="30"
            ></el-table-column>
            <el-table-column
              prop="mobileNo"
              label="手机号"
              min-width="30"
            ></el-table-column>
          </el-table>
          <div style="text-align: center; margin-top: 10px">
            <el-button type="primary" @click="diffNormalUser()">确定</el-button>
            <el-button
              @click="
                toggleSelection1();
                showcooperaterDialogVisible = false;
              "
              >取消</el-button
            >
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!-- 添加新注册的协调人 -->
    <el-dialog
      title="添加新协调人"
      center
      :visible.sync="addContacterDialogVisible"
      width="500px"
    >
      <div>
        <div id="">
          姓&nbsp;&nbsp;&nbsp;&nbsp;名：<el-input
            v-model="victimName"
            placeholder="请输入姓名"
            style="width: 300px"
          ></el-input>
        </div>
        <div style="margin-top: 10px">
          手机号：<el-input
            v-model="nationalMobile"
            placeholder="请输入姓名"
            style="width: 300px"
          ></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addContacterDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="newDJXid()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import jiesuan from "./jiesuan.vue";
import ParheaderVue from "./parheader.vue";
import Parinf from "./Parinf.vue";
import finishDetails from "@/components/cmd_center/finishDetails.vue";
import jianbao from "./jianbao";
import getObj from "@/util/constants.js";
import {
  closeOrdinaryCase,
  addbrief,
  uploadFile,
  noticeAccessCaseLiability,
  pstnCallLst,
  getCasedetail1,
  getfinishSureCase,
  closeCase,
  listSubUser,
  creatBasic,
  diffNormalUser,
  listNormalUser,
  listDomestic,
  diffDomestic,
  regulatorlistservice,
  userlist_regulator,
  restart_rescue_case
} from "@/views/axios/api.js";
import axios from "axios";
export default {
  data() {
    return {
      ztfy:0,
      comments: "",
      satisfied: "0",
      dialogVisible: false,
      closeText: "",
      dialogFormVisible: false,
      dialogFormVisible1: false,
      centerDialogVisible2: false,
      centerDialogVisible3: false,
      addContacterDialogVisible: false,
      showcooperaterDialogVisible: false,
      activeName: "second",
      pstnCallLstList: [],
      token: JSON.parse(window.localStorage.getItem("data")).data,
      fileList: [],
      uploadBtn: false,
      fileUrl: [],
      description: "录音",
      descriptionTo: "",
      descriptionFrom: "",
      jbTitle: "",
      uploadIdText: "1",
      valueSelect: "",
      detailLists: [],
      detailList: {
        obj: {
          obj: {
            incidentType: "",
            subRegulatorIdName:'',
          },
        },
      },
      activeIndex: 0,
      detailsTypeName: "",
      rescueFee: "",
      medicFee: "",
      otherFee: "",
      totalFee: "",
      cooperaterData: [], //所有联系人
      cooperaterData1: [], //所有联系人
      cooperaterDataList: [], //当前案件未修改之前的记录
      cooperaterDataListCheck: [], //当前案件修改之后
      victimName: "",
      nationalMobile: "",
      closeTxt: "",
      instiId:JSON.parse(window.localStorage.getItem("insti")).id,
    };
  },
  components: {
    jiesuan,
    ParheaderVue,
    Parinf,
    finishDetails,
    jianbao,
  },
  mounted() {
    this.activeIndex = this.$route.query.index || 0;
    this.pstnCallLst();
    this.getCasedetail();
    console.log(this.detailList.obj.obj.caseState,'caseStatecaseStatecaseStatecaseState')
    // if(this.detailList.obj.obj.caseState == 190) {
    //   alert(111)
    // }
  },
  methods: {
    statusReset() {
      const data = {
        token: this.token,
        caseId: this.detailList.obj.obj.id
      };
      restart_rescue_case(data)
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success("案件状态重置成功");
            this.getCasedetail(); // 刷新案件详情
            // 刷新当前页面
            this.$router.go(0);
          } else {
            this.$message.error(res.data.msg || "操作失败");
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("网络错误，请稍后重试");
        });
    },
    jyfychange(jyfy) {
     this.otherFee = this.ztfy - jyfy
    },

    setPoint(num) {
      return getObj.pt2txt(num).node;
    },
    setTime(str) {
      return getObj.time(str);
    },
    offerclick() {
      console.log(this.detailList);
      //  return
      this.$router.push({
        name: "Comlookinf",
        params: {
          token: this.token,
        },
        query: {
          typeId: this.$route.query.typeId,
          caseid: this.detailList.obj.obj.id,
          bidId: this.$route.query.bidId,
        },
      });
    },
    caseEditor() {
      let name = "";
      if (this.detailList.obj.obj.incidentType == "600") {
        name = "newstar1";
      } else {
        name = "callCase1";
      }
      this.$router.push({
        name,
        params: { caseList: this.detailList.obj },
        query: {
          typeId: this.detailList.obj.obj.incidentType,
          caseId: this.detailList.obj.obj.id,
        },
      });
    },
    sureFun() {
      //确认案件已完成
      console.log(this.detailLists[0].obj.obj);
      // if (
      //   this.detailLists[0].obj.obj.incidentDesc ==
      //     "<zh-CN></zh-CN><en-US></en-US>" ||
      //   this.detailLists[0].obj.obj.incidentDesc == null ||
      //   this.detailLists[0].obj.obj.incidentDesc == undefined ||
      //   this.detailLists[0].obj.obj.incidentDesc == "未填写"
      // ) {
      //   this.$message.error("服务经过不能为空");
      //   return;
      // }
      //  return
      this.totalFee =
        Number(this.medicFee) + Number(this.otherFee) + Number(this.rescueFee);
      // if(this.totalFee == 0 ) return this.$message.error('总费用不能为0')
      // if (this.medicFee < 0 || this.otherFee < 0 || this.rescueFee < 0) {
      //   this.$message.error("费用不能为负数");
      //   return;
      // }
      console.log(this.satisfied);
      if (this.satisfied == "0") {
        this.$message.error("回访结果不能为空");
        return;
      }
      if (this.detailList.obj.obj.incidentType != 800) {
        var data = {
          token: this.token,
          id: this.detailList.obj.obj.id,
          totalFee: this.totalFee || 0,
          medicFee: this.medicFee || 0,
          otherFee: this.otherFee || 0,
          rescueFee: this.rescueFee || 0,
          closeText: this.closeText,
        };
      } else {
        var data = {
          token: this.token,
          id: this.detailList.obj.obj.id,
          totalFee: this.totalFee || 0,
          medicFee: this.medicFee || 0,
          otherFee: this.otherFee || 0,
          rescueFee: this.rescueFee || 0,
          closeText: this.closeText,
          satisfied: this.satisfied,
          comments: this.comments,
        };
      }

      getfinishSureCase(data)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.$message.success("操作成功");
            this.dialogFormVisible = false;
            this.pstnCallLst();
            this.getCasedetail();
            console.log();
            this.$router.push({
              name: "Homestart1",
              query: {
                typeId: this.detailList.obj.obj.incidentType,
              },
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    openWork() {
      this.$store.commit("workData", this.detailList.obj.obj);
      this.$store.commit("workBtnFun", true);
    },
    zrrd() {
      noticeAccessCaseLiability({
        token: this.token,
        id: this.detailList.obj.obj.id,
      })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success("提醒成功");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addbrief() {
      if (!this.jbTitle) return this.$message.error("回访内容不能为空");
      // if (!this.uploadIdText) return this.$message.error("简报描述不能为空");
      var data = {
        token: this.token,
        title: this.jbTitle,
        incidentId: this.detailList.obj.obj.id,
        detail: this.uploadIdText,
        uploadIds: this.valueSelect,
      };
      addbrief(data)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.$message.success("添加成功");
            this.jbTitle = "";
            this.uploadIdText = "1";
            this.valueSelect = "";
            this.centerDialogVisible2 = false;
            this.getCasedetail();
            this.$parent.getCompleteCase();
            this.$parent.getnowCase();
           
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //上传
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    beforeAvatarUpload(file) {
      const isLt8M = file.size / 1024 / 1024 < 8;
      if (!isLt8M) {
        this.$message.error("上传头像图片大小不能超过 8MB!");
      }
      return isLt8M;
    },
    requestFile(param) {
      this.uploadBtn = true;
      var fileObj = param.file;
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      var form = new FormData(); // FormData 对象
      var token = JSON.parse(window.localStorage.getItem("data")).data;
      form.append("file", fileObj); // 文件对象
      form.append("token", token); // 文件对象
      axios
        .post(SEVSRS + "rescue/case/upload_file", form, config)
        .then((res) => {
          if (res.data.code == 0) {
            this.fileUrl.push(res.data.obj);
            this.uploadBtn = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    uploadFileFun() {
      var arr = [];
      this.fileUrl.forEach((item) => {
        var obj = {
          description: this.description,
          objType: 100,
          extra: `{from:${this.descriptionFrom},to:${this.descriptionTo}}`,
          type: this.detailList.obj.obj.caseState,
          objId: this.detailList.obj.obj.id,
          url: item,
        };
        arr.push(obj);
      });
      var data = {
        token: this.token,
        caseId: this.detailList.obj.obj.id,
        tUploadCnts: JSON.stringify(arr),
      };
      uploadFile(data)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.$message.success("添加成功");
            this.centerDialogVisible3 = false;
            this.$parent.getnowCase();
            this.$parent.getCompleteCase();
          }
        })
        .catch((err) => {
          console.log(res);
        });
    },
    pstnCallLst() {
      pstnCallLst({
        token: this.token,
      })
        .then((res) => {
          this.pstnCallLstList = res.data.obj;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCasedetail() {
      //获取详情
      var data = {
        token: this.token,
        caseId: this.$route.query.caseid,
      };
      getCasedetail1(data).then((res) => {
        console.log(res);
        this.detailLists = res.data.obj;
        this.detailList = this.detailLists[this.activeIndex];
        // if (this.detailList.obj.obj.caseState == 190) {
          console.log(this.detailList.obj.obj.incidentType);
          if (this.detailList.obj.obj.incidentType == 800) {
            console.log(this.detailLists[this.activeIndex])
            if(this.detailLists[this.activeIndex].obj.feelst.length > 0) {
              console.log(this.detailLists[this.activeIndex].obj.feelst[0].rescueFee)
            this.rescueFee = this.detailLists[this.activeIndex].obj.feelst[0].rescueFee;
            }
          if(this.detailList.obj.obj.subRegulatorId != '' && this.detailList.obj.obj.subRegulatorId != null && this.detailList.obj.obj.subRegulatorId != undefined) {
            regulatorlistservice({
            token:JSON.parse(window.localStorage.getItem("data")).data,
            regulatorId:this.detailList.obj.obj.regulatorId,
            subRegulatorId:this.detailList.obj.obj.subRegulatorId
          }).then((res1)=>{
           console.log(this.detailList.obj.obj.accidentType)
            for(var i = 0; i<res1.data.obj.length; i++) {
              if(res1.data.obj[i].serviceType == this.detailList.obj.obj.accidentType) {
                this.ztfy = res1.data.obj[i].amount
                console.log(res1.data.obj[i].amount)
                this.otherFee = res1.data.obj[i].amount - this.rescueFee
              }
            }
          })
          }
           
            // if (
            //   this.detailList.obj.obj.accidentType == "开锁服务" ||
            //   this.detailList.obj.obj.accidentType == "油烟机清洗" ||
            //   this.detailList.obj.obj.accidentType == "油烟机拆洗" ||
            //   this.detailList.obj.obj.accidentType == "保洁2小时" ||
            //   this.detailList.obj.obj.accidentType == "保洁4小时" ||
            //   this.detailList.obj.obj.accidentType ==
            //     "擦玻璃小户型（100平米下）" ||
            //   this.detailList.obj.obj.accidentType ==
            //     "擦玻璃大户型（100-150平米）"
            // ) {
            //   this.otherFee = 50;
            // } else {
            //   this.otherFee = 41;
            // }
            
          }
        // }
         
       console.log(this.detailList.obj.obj)
        this.detailsTypeName = this.detailLists[this.activeIndex].obj.incidentTypeStr;
        
        this.$forceUpdate();
      });
     
      console.log(this.detailList.obj.obj)
      
    },
    activeFun(index, name) {
      this.activeIndex = index;
      console.log(this.activeIndex);

      this.detailList = this.detailLists[index];
      
      this.detailsTypeName = name;
      this.getCasedetail();
      var url = "";
      if (SEVSRS == "http://api.test.dajiuxing.com.cn/") {
        url = "http://www.test.dajiuxing.com.cn/";
      } else {
        url = "http://www.dajiuxing.com.cn/";
      }
      // window.history.pushState( null, null, `djxwork/#/cmd_center/caseDetails?caseid=${this.$route.query.caseid}&index=${index}&subRegulatorIdname=${this.$route.query.subRegulatorIdname}`);
      // window.location.href("http://www.test.dajiuxing.com.cn/djxwork/#/cmd_center/caseDetails?caseid=" + this.$route.query.caseid + '&index='+ index +'&subRegulatorIdname=' + item.subRegulatorIdname);
      window.history.replaceState(
        null,
        null,
        `${url}djxwork/#/cmd_center/caseDetails?caseid=${this.$route.query.caseid}&index=${index}&subRegulatorIdname=${this.$route.query.subRegulatorIdname}`
      );
      return;
      this.$router.push({
        name: "caseDetails",
        query: { caseid: this.$route.query.caseid, index },
      });
    },
    closeCase() {
      console.log(this.detailLists[this.activeIndex].obj.obj.id)
      // return
      var data = {
        token: this.token,
        caseId: this.detailLists[this.activeIndex].obj.obj.id,
        text: this.closeTxt ? this.closeTxt : "",
      };
      closeCase(data)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.$message.success("案件已关闭");
            this.$router.go(-1);
            this.dialogFormVisible1 = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSelectionChange(val) {
      this.cooperaterDataListCheck = val;
    },
    handleSelectionChange1(val) {
      this.ruserDataListCheck = val;
    },
    handleClick(tab, event) {
      console.log(tab);
    },
    listSubUser() {
      var data = {
        token: this.token,
        start: 0,
        count: 100,
        all: 1,
      };
      listSubUser(data)
        .then((res) => {
          console.log(res);
          this.cooperaterData = res.data.obj;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //创建大救星账户
    newDJXid() {
      if (this.victimName == "") {
        return this.$message.error("出险人姓名不能为空");
      } else if (this.nationalMobile == "") {
        return this.$message.error("手机号不能为空");
      }
      var data = {
        token: this.token,
        name: this.victimName,
        nationalMobile: this.nationalMobile,
      };
      creatBasic(data)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.$message.success("创建成功");
            this.addContacterDialogVisible = false;
            this.cooperaterData1.push(res.data.obj);
            this.victimName = "";
            this.nationalMobile = "";
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    diffNormalUser() {
      var fids = "";
      this.ruserDataListCheck.forEach((item, index) => {
        if (index < this.ruserDataListCheck.length - 1) {
          fids += "fids=" + item.id + "&";
        } else {
          fids += "fids=" + item.id;
        }
      });
      var data = {
        token: this.token,
        caseId: this.caseId,
      };
      diffNormalUser(data, fids)
        .then((res) => {
          if (res.data.code == 0) {
            this.showcooperaterDialogVisible = false;
            this.$message.success("添加成功");
            this.getData();
          }
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    listDomestic(id) {
      var data = {
        token: this.token,
        start: 0,
        count: 100,
        caseId: id,
      };
      listDomestic(data)
        .then((res) => {
          this.cooperaterDataList = res.data.obj;
          var cooperaterDataList = [];
          this.cooperaterDataList.forEach((item) => {
            this.cooperaterData.forEach((item1) => {
              if (item1.id == item.id) {
                cooperaterDataList.push(item1);
              }
            });
          });
          this.cooperaterDataList = cooperaterDataList;
          this.toggleSelection(cooperaterDataList);
        })
        .catch((err) => {
          console.log(err);
        });
      var data1 = {
        token: this.token,
        caseId: id,
      };
      listNormalUser(data1)
        .then((res) => {
          console.log(res);
          this.cooperaterData1 = res.data.obj;
          setTimeout(() => {
            this.toggleSelection1(this.cooperaterData1);
          }, 500);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toggleSelection(rows) {
      console.log(rows);
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    toggleSelection1(rows) {
      console.log(rows);
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable1.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable1.clearSelection();
      }
    },
    diffDomestic() {
      var fids = "";
      this.cooperaterDataListCheck.forEach((item, index) => {
        fids += "fids=" + item.id + "&";
      });
      var oids = "";
      this.cooperaterDataList.forEach((item, index) => {
        if (index < this.cooperaterDataList.length - 1) {
          oids += "oids=" + item.id + "&";
        } else {
          oids += "oids=" + item.id;
        }
      });
      var data = {
        token: this.token,
        caseId: this.caseId,
      };
      diffDomestic(data, fids, oids)
        .then((res) => {
          if (res.data.code == 0) {
            this.showcooperaterDialogVisible = false;
            this.$message.success("添加成功");
          }
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toHelp() {
      console.log(this.detailLists);
      // return

      if (
        this.detailLists[this.activeIndex].obj.victimList[0].obj
          .insurancePolicyNo == "" ||
        this.detailLists[this.activeIndex].obj.victimList[0].obj
          .insurancePolicyNo == undefined
      ) {
        this.$message.error("保单号不能为空");
        return;
      }
      
      // 直接跳转到启动救援页面，不显示附件列表弹框
      this.$router.push({
        path: "/cmd_center/caseindex/helpStart",
        query: {
          typeId: this.detailList.obj.obj.incidentType,
          caseid: this.$route.query.caseid,
        },
      });
      
      // return
      //  if(this.detailLists[0].obj.victimList[0].obj.insurancePolicyNo == '' || this.detailLists[0].obj.victimList[0].obj.insurancePolicyNo == null || this.detailLists[0].obj.victimList[0].obj.insurancePolicyNo == undefined) {
    },
    
    /**
     * 一键提取上门信息
     * 复制案件号、服务地址、服务经过、联系人姓名+电话等信息
     */
    extractServiceInfo() {
      try {
        // 构建要复制的信息
        let info = '';
        
        // 1. 案件号
        if (this.detailList.obj.obj.caseNo) {
          info += `1.案件号：${this.detailList.obj.obj.caseNo}\n`;
        } else {
          info += `1.案件号：暂无\n`;
        }
        
        // 2. 服务地址 - 出险地-城市+出险地-详细地址
        let address = '';
        
        // 获取出险地-城市
        let city = '';
        if (this.detailList.obj.caseCity) {
          city = this.detailList.obj.caseCity;
        }
        
        // 获取出险地-详细地址
        let detailAddr = '';
        if (this.detailList.obj.generalLocation && this.detailList.obj.generalLocation.addr) {
          detailAddr = this.detailList.obj.generalLocation.addr;
          // 清理地址中的多语言标签
          detailAddr = detailAddr.replace(/<zh-CN>(.*?)<\/zh-CN>/g, '$1');
          detailAddr = detailAddr.replace(/<en-US>.*?<\/en-US>/g, '');
          detailAddr = detailAddr.replace(/\s+/g, ' ').trim();
        }
        
        // 组合地址：出险地-城市+出险地-详细地址
        if (city && detailAddr) {
          address = `${city}${detailAddr}`;
        } else if (city) {
          address = city;
        } else if (detailAddr) {
          address = detailAddr;
        } else {
          address = '暂无';
        }
        
        info += `2.服务地址：${address || '暂无'}\n`;
        
        // 3. 服务经过
        let serviceDesc = '';
        if (this.detailList.obj.obj.incidentDesc) {
          // 如果是多语言格式，提取中文内容
          if (this.detailList.obj.obj.incidentDesc.includes('<zh-CN>')) {
            const match = this.detailList.obj.obj.incidentDesc.match(/<zh-CN>(.*?)<\/zh-CN>/);
            serviceDesc = match ? match[1] : this.detailList.obj.obj.incidentDesc;
          } else {
            serviceDesc = this.detailList.obj.obj.incidentDesc;
          }
        }
        info += `3.服务经过：${serviceDesc || '暂无'}\n`;
        
        // 4. 联系人姓名+电话
        let contactInfo = '';
        if (this.detailList.obj.obj.reportUser && this.detailList.obj.obj.reporterContact) {
          contactInfo = `${this.detailList.obj.obj.reportUser} ${this.detailList.obj.obj.reporterContact}`;
        } else if (this.detailList.obj.obj.reportUser) {
          contactInfo = this.detailList.obj.obj.reportUser;
        } else if (this.detailList.obj.obj.reporterContact) {
          contactInfo = this.detailList.obj.obj.reporterContact;
        } else {
          contactInfo = '暂无';
        }
        info += `4.联系人姓名+电话：${contactInfo}\n`;
        
        // 5. 预期服务时间
        let expectedServiceTime = '';
        if (this.detailList.obj.obj.incidentTs) {
          // 格式化时间显示
          const date = new Date(this.detailList.obj.obj.incidentTs);
          expectedServiceTime = date.toLocaleString('zh-CN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          });
        } else {
          expectedServiceTime = '暂无';
        }
        info += `5.预期服务时间：${expectedServiceTime}`;
        
        // 复制到剪贴板
        if (navigator.clipboard && window.isSecureContext) {
          // 现代浏览器使用 Clipboard API
          navigator.clipboard.writeText(info).then(() => {
            this.$message.success('上门信息已复制到剪贴板');
          }).catch(() => {
            this.fallbackCopyTextToClipboard(info);
          });
        } else {
          // 降级方案
          this.fallbackCopyTextToClipboard(info);
        }
        
      } catch (error) {
        console.error('提取信息失败:', error);
        this.$message.error('提取信息失败，请重试');
      }
    },
    
    /**
     * 降级复制方案
     */
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message.success('上门信息已复制到剪贴板');
        } else {
          this.$message.error('复制失败，请手动复制');
          console.log('复制的内容：', text);
        }
      } catch (err) {
        this.$message.error('复制失败，请手动复制');
        console.log('复制的内容：', text);
      }
      
      document.body.removeChild(textArea);
    },
  },
};
</script>

<style scoped="scoped">
.caseDetails {
  width: 1200px;
  margin: 0 auto;
  background-color: white;
  padding: 20px;
  padding-bottom: 50px;
}
.back {
  font-size: 18px;
  cursor: pointer;
}
.moreCase {
  text-align: center;
  margin-top: 20px;
}
.moreCase ul {
  overflow: hidden;
  background-color: #f1f5f8;
  display: inline-block;
  height: 30px;
  padding: 3px 4px;
}
.moreCase li {
  float: left;
  width: 150px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.moreCase li.active {
  background-color: white;
}
.title {
  margin: 10px 0;
}
.btnBox {
  margin: 20px 0;
}
.btnWorkbench {
  margin-top: 20px;
  text-align: right;
}
.btnWorkbench button {
  border: 5px solid #f8dc40;
  height: 45px;
  padding: 0 20px;
  background: #fbea8c;
  border-radius: 5px;
  color: #c27506;
  cursor: pointer;
  outline: none;
}
.btnWorkbench a {
  color: #c27506;
}
.jianbao > div {
  margin-bottom: 10px;
}
.jianbao div * {
  vertical-align: middle;
}
.jianbao span {
  display: inline-block;
  width: 80px;
  text-align: right;
}
.popBox li {
  margin-bottom: 10px;
}
.popBox .el-input {
  width: 300px;
}
.contactAddStyle {
  position: absolute;
  top: 90px;
  right: 20px;
  cursor: pointer;
  z-index: 9;
}
.contactAddStyle::before {
  content: "+";
  color: #00abf9;
  width: 15px;
  height: 15px;
  display: inline-block;
  border-radius: 7.5px;
  text-align: center;
  line-height: 15px;
  font-size: 16px;
  margin-right: 5px;
  border: 1px solid #00abf9;
}
</style>



// WEBPACK FOOTER //
// src/views/commonPage/details/index.vue